<template>
  <div class="search-group d-flex align-center">
    <v-menu
      v-model="isShow"
      transition="scale-transition"
      @close-on-content-click="false"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="fieldName"
          outlined hide-details dense
          :placeholder="placeholder"
          background-color="white" :disabled="disabled"
        >
          <template v-slot:append>
            <v-icon v-bind="attrs" v-on="on" @click:append="isShow = !isShow">
              mdi-magnify
            </v-icon>
          </template>
        </v-text-field>
      </template>
      <v-treeview
        class="treeview-container"
        :items="items"
        item-key="id"
        open-on-click
        v-model="active"
        :open.sync="open"
      >
        <template v-slot:label="{ item }">
          <div
            :class="{ 'selected-row': selectedItem && selectedItem.id === item.id }"
            @click.stop="selectItem(item)"
          >
            <v-icon>
              {{ setNodeIcon(item.type)  }}
            </v-icon>
            {{ item.name }}
          </div>
        </template>
      </v-treeview>
    </v-menu>
  </div>
</template>
<script>

import {mapGetters} from "vuex";

export default {
  name: "SearchGroup",
  props: ["searchNm", "placeholder", "items", "disabled"],
  data() {
    return {
      isShow: false,
      fieldName: "",
      selectedItem: null,
      active: [],
      open: []
    }
  },
  created() {
    this.fieldName = this.searchNm;
  },
  watch: {
    isShow(value) {
      if (value && this.fieldName) {
        const path = this.findPath(this.items, this.fieldName);
        if (path) {
          this.open = path.slice(0, path.length - 1);
          this.active = [path[path.length - 1]];
          this.selectedItem = this.findItem(this.items, this.fieldName);
        }
        else {
          this.selectedItem = null;
          this.active = [];
          this.open = [];
        }
      }
    }
  },
  computed: {
    ...mapGetters("login", {memberRole: "memberRole"})
  },
  methods: {
    setNodeIcon(type) {
      if (type === "ALL") {
        return "mdi-office-building";
      } else if (type === "ORG") {
        return "mdi-account-multiple";
      } else {
        return "mdi-account";
      }
    },
    findPath(items, fieldName, path = []) {
      for (const item of items) {
        const newPath = [...path, item.id];
        if (item.name === fieldName) {
          return newPath;
        }
        if (item.children) {
          const result = this.findPath(item.children, fieldName, newPath);
          if (result) return result;
        }
      }
      return null;
    },
    findItem(items, fieldName) {
      for (const item of items) {
        if (item.name === fieldName) {
          return item;
        }
        if (item.children) {
          const found = this.findItem(item.children, fieldName);
          if (found) {
            return found;
          }
        }
      }
    },
    selectItem(item) {
      this.isShow = true;
      this.selectedItem = item;
      this.fieldName = item.name;
      const path = this.findPath(this.items, item.name);
      if (path) {
        this.active = [path[path.length -1]];
        this.open = path.slice(0, path.length - 1);
        this.isShow = false;
        this.$emit("updateData", this.selectedItem);
      }
    },
  }
}
</script>

<style>
.search-group {
  flex: 1 1 auto;
}
.selected-row {
  background-color: #1772C7;
  color: white;
  border-radius: 4px;
  padding: 4px;
}
.treeview-container {
  max-height: 400px;
  overflow-y: auto;
}

.v-treeview-node {
  background-color: white !important;
}
</style>